module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/current-date/current-date.component.scss
// module id = ./src/app/shared/components/current-date/current-date.component.scss
// module chunks = main